import {
	MOBILE_L_BP,
	TABLET_M_BP,
	getAnchorStyles,
} from "@website-builder/utilities-index";
import styled from "styled-components";

export const BlogContentWrapper = styled.div`
	margin: 64px 0;
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		margin: 24px 0 64px 0;
	}

	.blog-content {
		& > *:not(:last-child) {
			margin-bottom: 1.5rem;
		}
		& > .grouped-text-wr:not(:last-child) {
			margin-bottom: 1rem;
		}
	}
`;

export const ItemWrapper = styled.div`
	&.blog-image-wrapper {
		padding: 10px;

		.blog-image {
			object-fit: cover;
			max-width: 100%;
			border-radius: 8px;
		}

		.blog-image-mobile {
			display: none;
		}
		@media only screen and (max-width: ${MOBILE_L_BP}px) {
			.blog-image-mobile {
				display: block;
			}
			.blog-image-desktop {
				display: none;
			}
		}
	}

	.subtitle {
		text-align: center;
		font-style: italic;
		color: var(--secondary-gray-dark);
		margin-top: 8px;
	}

	.sb-primary-btn {
		display: block;
		margin: 64px auto 0 auto;
	}

	.rich-text-wrapper {
		h2 {
			font-size: var(--fs-8, 32px);
			line-height: var(--lh-1, 32px);
			margin: 1rem 0;
			@media only screen and (max-width: ${TABLET_M_BP}px) {
				font-size: var(--fs-5, 22px);
			}
		}
		h3 {
			font-size: var(--fs-5, 22px);
			font-weight: 600;
			margin: 0.5 0;
			@media only screen and (max-width: ${TABLET_M_BP}px) {
				font-size: var(--fs-3, 18px);
			}
		}
		h4 {
			font-size: var(--fs-4, 18px);
			font-weight: 500;
			@media only screen and (max-width: ${TABLET_M_BP}px) {
				font-size: var(--fs-2, 16px);
				font-weight: 600;
			}
		}
		${getAnchorStyles()}
	}
`;

export const TableOfContentsWrapper = styled.div`
	position: sticky;
	top: ${({ isHeaderSticky }) => (isHeaderSticky ? "144px" : "64px")};
	margin-right: 24px;
	& > *:not(:last-child) {
		margin-bottom: 1.5rem;
		display: block;
	}
	.table-of-contents-heading {
		display: block;
		font-family: var(--theme-ff);
		color: var(--secondary-gray-dark, #67706b);
	}
	.table-of-contents-item {
		text-decoration: none;

		&:hover {
			color: var(--theme-primary);
		}
	}

	@media only screen and (max-width: ${TABLET_M_BP}px) {
		display: none;
	}
`;
